module.exports = __webpack_public_path__ + "static/assets/1660f9fc45778cfbc729900699fc8ce4.png";